<template>
  <div class="report-proficient-room-fee">
    <div class="table-container">
      <el-table :data="reportProficientRoomFeeInfo.fees" border style="width: 100%" >
        <!-- 鍥哄畾鍒楋細鍩烘湰淇℃伅 -->
        <el-table-column prop="ownerName" :label="$t('reportProficientRoomFee.name')" align="center" fixed="left" width="120">
        </el-table-column>
        <el-table-column prop="objName" :label="$t('reportProficientRoomFee.roomNumber')" align="center" fixed="left" width="120">
        </el-table-column>
        <el-table-column prop="ownerLink" :label="$t('reportProficientRoomFee.phone')" align="center" fixed="left" width="120">
        </el-table-column>
        <el-table-column prop="builtUpArea" :label="$t('reportProficientRoomFee.area')" align="center" fixed="left" width="100">
        </el-table-column>
        <el-table-column prop="feeTypeCdName" :label="$t('reportProficientRoomFee.feeType')" align="center" fixed="left" width="120">
        </el-table-column>
        <el-table-column prop="feeName" :label="$t('reportProficientRoomFee.feeName')" align="center" fixed="left" width="120">
        </el-table-column>
        
        <!-- 鍔ㄦ佸垪锛氬勾搴﹁垂鐢ㄦ暟鎹?-->
        <el-table-column v-for="(item, index) in reportProficientRoomFeeInfo.listColumns" :key="index"
          :label="item + $t('reportProficientRoomFee.year')" align="center" >
          <template slot-scope="scope">
            <el-link type="primary" @click="_showFeeDetail(scope.row, item)">
              {{ _getProficientRoomFeeValue(scope.row.reportFeeYearCollectionDetailDtos, item) }}
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-row :gutter="20" class="margin-top">
      <el-col :span="12">
        <div class="tip-text text-left">
          {{ $t('reportProficientRoomFee.tip') }}
        </div>
      </el-col>
      <el-col :span="12">
        <el-pagination :current-page.sync="pagination.current" :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.size" :total="pagination.total" layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </el-col>
    </el-row>
    <view-fee-detail ref="viewFeeDetail"></view-fee-detail>
  </div>
</template>

<script>
import { queryReportFeeYear } from '@/api/report/reportProficientApi'
import ViewFeeDetail from '@/components/report/viewFeeDetail'

export default {
  name: 'ReportProficientRoomFee',
  components: {
    ViewFeeDetail
  },
  props: {
    conditions: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      reportProficientRoomFeeInfo: {
        fees: [],
        listColumns: [2023]
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
  },
  methods: {
    open(params) {
      this.conditions = params
      this.listReportProficientRoomFee()
    },
    handleSwitch(params) {
      console.log(params)
      this.clearReportProficientRoomFeeInfo()
      this.listReportProficientRoomFee()
    },
    async listReportProficientRoomFee() {
      try {
        const params = {
          ...this.conditions,
          page: this.pagination.current,
          row: this.pagination.size,
          objType: '3333'
        }
        const { data, records } = await queryReportFeeYear(params)

        this.reportProficientRoomFeeInfo.fees = data
        this.pagination.total = records

        if (data && data.length > 0) {
          this.reportProficientRoomFeeInfo.listColumns = []
          let maxColumns = data[0].reportFeeYearCollectionDetailDtos

          data.forEach(item => {
            if (item.reportFeeYearCollectionDetailDtos.length > maxColumns.length) {
              maxColumns = item.reportFeeYearCollectionDetailDtos
            }
          })

          maxColumns.forEach(item => {
            this.reportProficientRoomFeeInfo.listColumns.push(item.collectionYear)
          })
        }
      } catch (error) {
        console.log('获取房屋费台账失败', error)
      }
    },
    _getProficientRoomFeeValue(reportFeeYearCollectionDetailDtos, year) {
      const item = reportFeeYearCollectionDetailDtos.find(d => d.collectionYear === year)
      return item ? item.receivedAmount : '0.00'
    },
    clearReportProficientRoomFeeInfo() {
      this.reportProficientRoomFeeInfo = {
        fees: [],
        listColumns: [2023]
      }
    },
    _showFeeDetail(fee, year) {
      this.$refs.viewFeeDetail.open({
        roomName: fee.objName,
        feeId: fee.feeId,
        configId: fee.configId,
        payerObjId: fee.objId,
        curYear: year
      })
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.listReportProficientRoomFee()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.listReportProficientRoomFee()
    }
  }
}
</script>

<style lang="scss" scoped>
.report-proficient-room-fee {
  .table-container {
    overflow-x: auto;
    
    // 确保表格容器有足够的宽度来显示滚动条
    .el-table {
      min-width: 100%;
      
      // 设置表格的最小宽度，确保横向滚动生效
      &::v-deep .el-table__body-wrapper {
        overflow-x: auto;
      }
    }
  }

  .margin-top {
    margin-top: 20px;
  }

  .tip-text {
    padding: 10px;
    color: #999;
    font-size: 12px;
  }
}
</style>
